






































import _ from 'lodash';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsSelect',
	components: { DmsWrapper },
	props: {
		selectList: {
			type: Array,
			required: true,
		},
		asValue: { type: String, default: 'Value' },
		multiple: Boolean,
		multiplelimit: Number,
		value: [String, Number, Boolean, Array],
		filterMethod: { type: Function, default: (e: any) => e },
		filterable: Boolean,
		allowCreate: Boolean,
		required: Boolean,
		span: {
			type: Number,
			default: 24,
		},
		noLabelAlign: { type: Boolean, default: false },
		remote: Boolean,
		remoteMethod: { type: Function, default: (e: any) => e },
		changeMethod: { type: Function, default: (e: any) => e },
		focusMethod: { type: Function, default: (e: any) => e },
		loading: Boolean,
		showDisabledItems: { type: Boolean, default: false },
		showSelectAll: { type: Boolean, default: false },
		selectAllLabel: { type: String, default: 'Select All' },
	},
	data() {
		return {
			isDropdownOpen: false,
		};
	},
	computed: {
		selectPlaceholderText(): string | undefined {
			return this.placeholderText ? `-- ${this.placeholderText} --` : undefined;
		},
		isBooleanType(): boolean {
			return this.selectList[0] ? typeof (this.selectList as any)[0][this.asValue] === 'boolean' : false;
		},
		selectValue(): any {
			const boolCheckValue = this.boolToStr(this.value as boolean | string);
			if (this.allowCreate && !this.selectList.includes((item: any) => item[this.asValue] === this.value)) {
				return this.value;
			}
			if (Array.isArray(this.value)) {
				const filteredValue = this.checkArrayValues().filter((val: any) => val !== '__SELECT_ALL__');
				return filteredValue;
			}
			return this.selectList?.some((item: any) => item[this.asValue] === this.value)
				? boolCheckValue
				: null;
		},
		selectListFiltered(): any[] {
			return (this.selectList as any[])
				.filter(this.filterMethod)
				.filter(
					(value: { Value: string, Disabled: boolean }) => (this.selectValue === value.Value || (this.showDisabledItems || !value.Disabled)),
				);
		},
		clearableCmp(): boolean {
			return !this.isDropdownOpen && this.clearable;
		},
		filterableCmp(): boolean {
			return this.filterable || this.allowCreate;
		},
		isAllSelected(): boolean {
			if (!this.multiple || !Array.isArray(this.value)) return false;
			const currentValue = this.value as any[];
			const availableValues = this.selectListFiltered
				.filter((item: any) => !item.Disabled)
				.map((item: any) => this.boolToStr(item[this.asValue]));
			return availableValues.length > 0 && availableValues.every((val: any) => currentValue.includes(val));
		},
	},
	methods: {
		checkArrayValues() {
			return (this.value as any[]).filter(
				(element: boolean | string | number) => this.selectList.some((item: any) => item[this.asValue] === element),
			);
		},
		boolToStr(value: boolean | string) {
			return !_.isNil(value) && this.isBooleanType ? value.toString() : value;
		},
		optionLabel(item: { Label: string, Text: string }) {
			return item.Label ? `${item.Text} (${item.Label})` : item.Text;
		},
		handleSelectChange(value: string | number | any[]) {
			if (Array.isArray(value) && value.includes('__SELECT_ALL__')) {
				this.toggleSelectAll();
				return;
			}
			if (this.changeMethod) {
				this.changeMethod(value);
			}
			this.updateValue(value);
		},
		updateValue(value: string | number | any[]) {
			if (value === '') this.$emit('update:value', null);
			else if (this.isBooleanType && !_.isNil(value)) {
				if (Array.isArray(value)) {
					this.$emit('update:value', value.map((v: string) => JSON.parse(String(v))));
				} else {
					this.$emit('update:value', JSON.parse(String(value)));
				}
			} else this.$emit('update:value', value);
		},
		visibleChange(value: boolean) {
			this.isDropdownOpen = value;
		},
		toggleSelectAll() {
			if (!this.multiple) return;
			let availableValues = this.selectListFiltered
				.filter((item: any) => !item.Disabled)
				.map((item: any) => this.boolToStr(item[this.asValue]));
				if (this.showSelectAll && this.multiplelimit && this.multiplelimit > 0) {
				availableValues = availableValues.slice(0, this.multiplelimit);
			}
			if (this.isAllSelected) {
				this.$emit('update:value', []);
			} else {
				const newValue = this.isBooleanType
					? availableValues.map((v: string | boolean) => JSON.parse(String(v)))
					: availableValues;
				this.$emit('update:value', newValue);
			}
			if (this.changeMethod) {
				this.changeMethod(this.isAllSelected ? [] : availableValues);
			}
		},
	},
});
